import React from "react";
import { View } from "react-native";

import RNModal from "react-native-modal";
import { StyleSheet } from "react-native";
import AeStyles from "ae-style";

const ModalOverlay = ({ children, ...props }) => {
	let customStyle = [styles.modal, props.styles];

	return (<RNModal {...props} style={customStyle} >
		<View style={styles.background}>{children}</View>
	</RNModal>);
};

const styles = StyleSheet.create({
	modal: {
		margin: 0
	},
	background: {
		backgroundColor: AeStyles.colors.overlay,
		flexGrow: 1
	}
});

export default ModalOverlay;